import Apify from '@module/apify';

export default Apify({
  createSession: {
    path: '/api/v4/auth/session',
    method: 'POST',
  },

  signout: {
    path: '/api/v4/auth/session',
    method: 'DELETE',
  },

  signup: {
    path: '/api/v4/users/signup',
    method: 'POST',
  },

  completePayment: {
    path: '/api/v4/users/complete-payment',
    method: 'POST',
  },

  updatePaymentMethod: {
    path: '/api/v4/users/payment-methods',
    method: 'PUT',
  },

  validate: {
    path: 'api/v4/users/validate',
    pathExt: true,
    method: 'POST',
  },

  getCurrentUser: {
    path: '/api/v4/auth/session',
  },

  updateUser: {
    path: '/api/v4/users',
    method: 'PUT',
  },

  updateUserLanguage: {
    path: '/api/v4/users/language',
    method: 'PUT',
  },

  unsubscribeUserOnboarding: {
    path: '/api/v4/users/pm-onboarding-unsubscribe',
    pathExt: true,
    method: 'POST',
  },

  updatePassword: {
    path: '/api/v4/users/password',
    method: 'PUT',
  },

  requestPasswordReset: {
    path: '/api/v4/auth/password',
    method: 'POST',
  },

  resetPassword: {
    path: '/api/v4/auth/password',
    method: 'PUT',
  },

  getContacts: {
    path: '/api/v4/contacts',
    method: 'GET',
  },

  addContact: {
    path: '/api/v4/contacts',
    method: 'POST',
  },

  editContact: {
    path: '/api/v4/contacts/{contactId}',
    pathExt: true,
    method: 'PUT',
  },

  removeContact: {
    path: '/api/v4/contacts/batch',
    method: 'POST',
  },

  assignTransfer: {
    path: '/api/v4/users/assign-transfer',
    method: 'POST',
  },

  uploadPicture: {
    path: '/api/v4/images/thumbs/profile_pictures',
    method: 'POST',
  },

  verifyEmail: {
    path: '/api/v4/users/email-verification/create-code',
    method: 'POST',
  },

  verifyOptIn: {
    path: '/api/v4/users/email-verification/opt-in',
    method: 'POST',
  },

  verifyOptOut: {
    path: '/api/v4/users/email-verification/opt-out',
    method: 'POST',
  },

  getUserRules: {
    path: '/api/v4/users/rules',
  },
});
